import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['bullet-list'])
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
      return (_openBlock(), _createElementBlock("li", {
        class: _normalizeClass([
				'bullet-list__item',
				`bullet-list__item--${_ctx.type}`,
				{ selectable: _ctx.selectable },
				{ 'selected input__field--valid': _ctx.selected === index },
			]),
        key: `bullet ${index}`,
        onClick: ($event: any) => (_ctx.clicked(index))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass([{ 'bullet-list__item--overflow': _ctx.overflow }]),
          innerHTML: item
        }, null, 10, _hoisted_3)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}